export default {
  GRADING_OPEN: "grading_open",
  GRADING_GUIDE_OPEN: "grading_guide_open",
  GRADINGPAGE_OPEN: "gradingpage_open",
};
